"use strict";

var keyboardAccessibility = require("./keyboardAccessibility");

let init = () => {
    $(".country-selector span.c-country-selector__dropdown-item").on("click", function (e) {
        var $this = $(this);
        var externalSite = $this.data("externalSite");
        var externalSiteUrl = $this.data("externalurl");

        if (!externalSite) {
            e.preventDefault();

            var $page = $(".page");
            var action = $page.data("action");
            var localeCode = $this.data("locale");
            var localeCurrencyCode = $this.data("currencycode");
            var queryString = $page.data("querystring");
            var url = $(".country-selector").data("url");

            $.ajax({
                url: url,
                type: "get",
                dataType: "json",
                data: {
                    code: localeCode,
                    queryString: queryString,
                    CurrencyCode: localeCurrencyCode,
                    action: action
                },
                success: function (response) {
                    $.spinner().stop();
                    if (response && response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        } else {
            window.location.href = externalSiteUrl;
        }
    });
    
    $(".country-selector span.c-country-selector__dropdown-item").on("keydown", function (e) {
        if(e.key && (e.key === "Enter" || e.key === "Space")) {
            $(this).trigger("click");
        }
    });

    keyboardAccessibility(".country-selector",
        {
            40: function ($countryOptions) { // down
                if ($(this).is(":focus")) {
                    $countryOptions.first().focus();
                } else {
                    $(":focus").next().focus();
                }
            },
            38: function ($countryOptions) { // up
                var $this = $(this);

                if ($countryOptions.first().is(":focus") || $this.is(":focus")) {
                    $this.focus();
                    $this.removeClass("show");
                } else {
                    $(":focus").prev().focus();
                }
            },
            27: function () { // escape
                var $this = $(this);

                $this.focus();
                $this.removeClass("show").children(".dropdown-menu").removeClass("show");
                $this.find(".dropdown-toggle").attr("aria-expanded", false);
            },
            9: function () { // tab
                $(this).removeClass("show").children(".dropdown-menu").removeClass("show");
                $this.find(".dropdown-toggle").attr("aria-expanded", false);
            }
        },
        function () {
            var $this = $(this);

            if (!($this.hasClass("show"))) {
                $this.addClass("show");
                $this.find(".dropdown-menu").addClass("show");
                $this.find(".dropdown-toggle").attr("aria-expanded", true)
            }
            return $this.find(".dropdown-country-selector").children("span.c-country-selector__dropdown-item");
        }
    );
};

module.exports = {
    init: init
};
